import React, { useContext } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import * as buttonActions from 'common/builder/actions/buttonActions'
import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { BlockType } from 'common/builder/constants/BlockType'
import { useBlock } from 'common/builder/hooks/useBlock'
import * as nextStepSelectors from 'common/builder/selectors/builder/nextStepSelectors'
import * as sourceSelectors from 'common/builder/selectors/builder/sourceSelectors'
import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import { exportSmartLink } from 'components/MCTextEditor/smartLinks/adapter'
import SmartLinkTypePicker from 'components/MCTextEditor/toolbar/popovers/SmartLinks/SmartLinkTypePicker'
import { EditorContext } from 'components/RichTextEditor/EditorContext'
import { analyticsService } from 'utils/services/analytics'

import { IToolPopover } from '../../toolbarInterfaces'

const SmartLinks: IToolPopover = ({ onSelect = () => undefined }) => {
  const dispatch = useAppDispatch()
  const { builderId, blockId, withHyperlinks } = useContext(MCEditorContext)
  const { processor } = useContext(EditorContext)
  const { block } = useBlock(builderId, blockId)

  const nextStepOptions = useAppSelector((state) =>
    sourceSelectors.getSmartLinkNextStepOptions(state, builderId, blockId),
  )

  const getCaption = () => {
    if (withHyperlinks) {
      return processor.getText().slice(processor.getSelection().start, processor.getSelection().end)
    } else if (block?.type === BlockType.EMAIL_TEXT) {
      return ''
    }

    return 'Link'
  }

  const handleLinkNextStepSelect = (type: string) => {
    const caption = getCaption()

    if (block?.type === BlockType.EMAIL_TEXT) {
      if (caption.length) {
        analyticsService.sendEvent('EMAIL.TEXT.HYPERLINK.CREATED')
      } else {
        analyticsService.sendEvent('EMAIL.TEXT.LINK.CREATED')
      }
    }

    const btn = dispatch<IButton>(
      buttonActions.createSmartLink(builderId, blockId, type, { caption }),
    )
    if (btn.id) {
      onSelect(exportSmartLink(btn.id), 1)
    }
  }

  const hasCtaButton = useAppSelector((state) =>
    nextStepSelectors.isWaCtaButtonActive(state, builderId, block.id),
  )

  return (
    <div className="p-x p-y-xs">
      <SmartLinkTypePicker
        onSelect={handleLinkNextStepSelect}
        options={nextStepOptions}
        hasCtaButton={hasCtaButton}
      />
    </div>
  )
}
export default SmartLinks
